import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Icomoon__facebook",
  "use": "Icomoon__facebook-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"Icomoon__facebook\"><path d=\"M464 0H48C21.6 0 0 21.6 0 48v416c0 26.4 21.6 48 48 48h208V288h-64v-64h64v-32c0-52.9 43.1-96 96-96h64v64h-64c-17.6 0-32 14.4-32 32v32h96l-16 64h-80v224h144c26.4 0 48-21.6 48-48V48c0-26.4-21.6-48-48-48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol